import { ChangeDetectionStrategy, Component, inject, OnInit, viewChild } from '@angular/core';
import { GeneralProjectService } from '@app/cem/project/services/general-project.service';
import { AppStorage } from '@app/common/services/data-api/app-storage.service';
import { HeaderComponent } from '@app/shared/components/header/header.component';
import { ButtonDirective } from '@progress/kendo-angular-buttons';
import { AgGridAngular } from 'ag-grid-angular';
import { DefaultTeamFracFleet, ProjectTeamFracFleetGridOptions, ProjectTeamFracFleetGridOptionsService } from './columns';

@Component({
  selector: 'app-project-team-frac-fleets',
  templateUrl: './project-team-frac-fleets.component.html',
  styleUrls: ['./project-team-frac-fleets.component.scss'],
  imports: [
    AgGridAngular,
    ButtonDirective,
    HeaderComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    ProjectTeamFracFleetGridOptionsService
  ],
})
export class ProjectTeamFracFleetsComponent implements OnInit {
  private generalProjectService = inject(GeneralProjectService);
  public projectTeamFracFleetGridOptionsService = inject(ProjectTeamFracFleetGridOptionsService);
  private appStorage = inject(AppStorage);

  private readonly agGridFF = viewChild(AgGridAngular);

  public projectTeamFracFleetsGridOptions: ProjectTeamFracFleetGridOptions;
  public currentAssetTeamId: number;
  public scenarioId: number;
  public loading: boolean = false;
  public editedFracFleets: Map<number, DefaultTeamFracFleet> = new Map<any, DefaultTeamFracFleet>();

  constructor() {
    this.projectTeamFracFleetsGridOptions = this.projectTeamFracFleetGridOptionsService.projectTeamFracFleetGridOptions;
  }

  ngOnInit() {
    this.appStorage.knownEvents.assetTeamSelected.subscribe(event => {
      if (event && event.AssetTeamId !== this.currentAssetTeamId) {
        this.currentAssetTeamId = event.AssetTeamId;
        this.loadDefaultTeams();
      }
    });
    this.appStorage.knownEvents.scenarioSelected.subscribe(event => {
      if (event && event.ScenarioId !== this.scenarioId) {
        this.scenarioId = event.ScenarioId;
        this.refreshData();
      }
    });
  }

  loadDefaultTeams() {
    this.generalProjectService.getDefaultProjecTeams(this.currentAssetTeamId, 3).then(
      teams => {
        this.projectTeamFracFleetGridOptionsService.DefaultProjectTeams = new Map(teams.map(a => [a.DefaultProjectTeamId, a]));
      }
    );
  }

  onGridReady(params) { }

  refreshData() {
    this.loading = true;
    this.generalProjectService.getProjectTeamFracFleetDefaults(this.scenarioId).then(
      rigs => {
        this.agGridFF().api.setGridOption('rowData', rigs);
        this.loading = false;
      }
    );
  }

  cancelEdit() {
    this.editedFracFleets = new Map<any, DefaultTeamFracFleet>();
    this.refreshData();
  }

  onCellValueChanged(e) {
    this.trackChanges(e);
  }

  onRowEditStopped(e) {
    this.trackChanges(e);
  }

  trackChanges(e) {
    let defaultTeamFracFleet: DefaultTeamFracFleet = {
      FracFleetId: e.data.FracFleetId,
      DefaultFracFleetId: e.data.DefaultFracFleetId,
      StimDefaultProjectTeamId: e.data.StimDefaultProjectTeamId,
      PostStimDefaultProjectTeamId: e.data.PostStimDefaultProjectTeamId,
      Name: e.data.Name
    };

    this.editedFracFleets.set(e.node.id, defaultTeamFracFleet);
  }

  saveChanges() {
    this.loading = true;
    let fracFleets = this.editedFracFleets.values();
    this.generalProjectService.addUpdateDefaultFracFleetTeams(Array.from(fracFleets)).subscribe(x => {
      this.editedFracFleets = new Map<any, DefaultTeamFracFleet>();
      this.loading = false;
      this.refreshData();
    });
  }
}